export const ADD_MEDICAMENTOS = "ADD_MEDICAMENTOS";
